window.onload = function () {
  const loader = document.querySelector(".bl_loader");
  if (loader) {
    // bl_loaderがあれば実行

    loader.classList.add("js_isLoaded");
  }
};
